import React, { useState } from 'react';
import { Section, FadeIn, CTAButton } from './ui';
import { ChevronDown } from 'lucide-react';
export const CTASection = () => {
  return <Section id="cta-principal" className="bg-rose-50 border-y border-rose-100 py-20" data-id="element-69">
      <FadeIn data-id="element-70">
        <div className="text-center max-w-2xl mx-auto" data-id="element-71">
          <h2 className="text-3xl sm:text-4xl font-serif text-navy-900 mb-6" data-id="element-72">
            Ya es tiempo de que alguien esté de tu lado.
          </h2>
          <p className="text-2xl text-rose-600 font-medium mb-12" data-id="element-73">
            Hoy ese alguien puedes ser TÚ MISMA.
          </p>
          <CTAButton data-id="element-74" />
          <div className="mt-6 text-sm text-gray-500 space-y-1" data-id="element-75">
            <p data-id="element-76">Acceso inmediato · Formato PDF</p>
            <p data-id="element-77">Descarga desde cualquier dispositivo</p>
          </div>
        </div>
      </FadeIn>
    </Section>;
};
export const FinalMessageSection = () => {
  return <Section className="bg-cream-100" data-id="element-78">
      <FadeIn data-id="element-79">
        <div className="max-w-3xl mx-auto" data-id="element-80">
          <h2 className="text-3xl sm:text-4xl font-serif text-navy-900 mb-8 text-center" data-id="element-81">
            Un último mensaje antes de que te vayas
          </h2>

          <div className="space-y-6 text-lg sm:text-xl text-gray-700 mb-12" data-id="element-82">
            <p data-id="element-83">Sé que quizás estás dudando. Quizás estás pensando:</p>
            <p className="italic text-navy-800" data-id="element-84">
              "¿Y si no me funciona?"
              <br data-id="element-85" />
              "¿Y si no tengo tiempo de leerlo?"
              <br data-id="element-86" />
              "¿Y si gasto el dinero y no cambia nada?"
            </p>
            <p data-id="element-87">Esos pensamientos son normales.</p>
            <p className="font-medium text-navy-900 mt-8" data-id="element-88">
              Pero también quiero que te hagas esta pregunta:
            </p>
            <p className="text-2xl font-serif text-rose-600 italic my-8 text-center" data-id="element-89">
              ¿Cuánto más tiempo estás dispuesta a seguir siendo la última en tu
              propia lista?
            </p>
            <p data-id="element-90">
              Porque cada día que pasa sin hacer nada... el agotamiento crece.
              El resentimiento crece. La distancia contigo misma crece.
            </p>
            <p data-id="element-91">
              Este libro no te pide que lo cambies todo de golpe. Solo te pide
              que empieces.
            </p>
            <p className="font-medium text-navy-900 text-center text-2xl mt-8" data-id="element-92">
              Y ese primer paso... puede cambiarlo todo.
            </p>
          </div>

          <div className="text-center mt-16" data-id="element-93">
            <CTAButton data-id="element-94" />
            <div className="mt-8 flex flex-wrap justify-center gap-4 text-sm text-gray-600" data-id="element-95">
              <span className="flex items-center gap-1" data-id="element-96">
                ✅ Acceso inmediato
              </span>
              <span className="flex items-center gap-1" data-id="element-97">✅ Formato PDF</span>
              <span className="flex items-center gap-1" data-id="element-98">
                ✅ Garantía de 7 días
              </span>
              <span className="flex items-center gap-1" data-id="element-99">
                ✅ Tuyo para siempre
              </span>
            </div>
          </div>
        </div>
      </FadeIn>
    </Section>;
};
export const FAQSection = () => {
  const faqs = [{
    q: '¿En qué formato llega?',
    a: 'PDF digital — lo lees en tu teléfono, tablet o computadora'
  }, {
    q: '¿Cuándo lo recibo?',
    a: 'Inmediatamente después del pago — acceso instantáneo'
  }, {
    q: '¿Está en español?',
    a: 'Sí, 100% en español, escrito para ti'
  }, {
    q: '¿Y si no me gusta?',
    a: 'Garantía de 7 días — te devolvemos tu dinero sin preguntas'
  }, {
    q: '¿Necesito experiencia previa?',
    a: 'No — está escrito para cualquier mujer desde cero'
  }, {
    q: '¿Funciona si tengo poco tiempo?',
    a: 'Sí — puedes leerlo en partes, a tu ritmo'
  }, {
    q: '¿Puedo compartirlo?',
    a: 'Es para uso personal — pero puedes regalárselo a quien lo necesite'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <Section className="bg-white" data-id="element-100">
      <FadeIn data-id="element-101">
        <h2 className="text-3xl sm:text-4xl font-serif text-navy-900 mb-12 text-center" data-id="element-102">
          Preguntas Frecuentes
        </h2>

        <div className="max-w-2xl mx-auto space-y-4" data-id="element-103">
          {faqs.map((faq, i) => <div key={i} className="border border-cream-200 rounded-xl overflow-hidden" data-id="element-104">
              <button className="w-full px-6 py-4 text-left flex justify-between items-center bg-cream-50 hover:bg-cream-100 transition-colors" onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-105">
                <span className="font-medium text-navy-900 text-lg" data-id="element-106">
                  {faq.q}
                </span>
                <ChevronDown className={`transform transition-transform ${openIndex === i ? 'rotate-180' : ''} text-rose-500`} data-id="element-107" />
              </button>
              {openIndex === i && <div className="px-6 py-4 bg-white text-gray-700 text-lg border-t border-cream-100" data-id="element-108">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </FadeIn>
    </Section>;
};
export const FooterSection = () => {
  const [modal, setModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="bg-navy-900 text-cream-100/60 py-8 text-center text-sm" data-id="element-109">
        <p className="mb-4" data-id="element-110">
          © {new Date().getFullYear()} Siempre Para Todos, Nunca Para Mí. Todos
          los derechos reservados.
        </p>
        <div className="flex justify-center gap-6" data-id="element-111">
          <button onClick={() => setModal('privacy')} className="underline hover:text-cream-100 transition-colors" data-id="element-112">
            Política de Privacidad
          </button>
          <button onClick={() => setModal('terms')} className="underline hover:text-cream-100 transition-colors" data-id="element-113">
            Términos y Condiciones
          </button>
        </div>
      </footer>

      {modal && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4" onClick={() => setModal(null)} data-id="element-114">
          <div className="bg-white rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto p-8 relative" onClick={e => e.stopPropagation()} data-id="element-115">
            <button onClick={() => setModal(null)} className="absolute top-4 right-4 text-gray-400 hover:text-gray-700 text-2xl leading-none" data-id="element-116">
              ✕
            </button>

            {modal === 'privacy' && <div className="space-y-4 text-gray-700" data-id="element-117">
                <h2 className="text-2xl font-serif text-navy-900 mb-6" data-id="element-118">
                  Política de Privacidad
                </h2>
                <p data-id="element-119">
                  Tu privacidad es importante para nosotros. Esta política
                  describe cómo recopilamos, usamos y protegemos tu información
                  personal.
                </p>
                <h3 className="font-medium text-navy-900 text-lg mt-6" data-id="element-120">
                  Información que Recopilamos
                </h3>
                <p data-id="element-121">
                  Recopilamos únicamente la información necesaria para procesar
                  tu compra: nombre, dirección de correo electrónico y datos de
                  pago. No almacenamos información de tarjetas de crédito
                  directamente; los pagos son procesados por plataformas seguras
                  de terceros.
                </p>
                <h3 className="font-medium text-navy-900 text-lg mt-6" data-id="element-122">
                  Uso de la Información
                </h3>
                <p data-id="element-123">
                  Tu información se utiliza exclusivamente para: procesar tu
                  pedido, enviarte el producto digital adquirido, y comunicarnos
                  contigo en caso de ser necesario respecto a tu compra.
                </p>
                <h3 className="font-medium text-navy-900 text-lg mt-6" data-id="element-124">
                  Protección de Datos
                </h3>
                <p data-id="element-125">
                  Implementamos medidas de seguridad para proteger tu
                  información personal. No vendemos, intercambiamos ni
                  transferimos tu información a terceros sin tu consentimiento.
                </p>
                <h3 className="font-medium text-navy-900 text-lg mt-6" data-id="element-126">
                  Cookies
                </h3>
                <p data-id="element-127">
                  Nuestro sitio puede utilizar cookies para mejorar tu
                  experiencia de navegación. Puedes configurar tu navegador para
                  rechazar cookies si lo prefieres.
                </p>
                <h3 className="font-medium text-navy-900 text-lg mt-6" data-id="element-128">
                  Cambios a esta Política
                </h3>
                <p data-id="element-129">
                  Nos reservamos el derecho de actualizar esta política en
                  cualquier momento. Los cambios serán publicados en esta
                  página.
                </p>
              </div>}

            {modal === 'terms' && <div className="space-y-4 text-gray-700" data-id="element-130">
                <h2 className="text-2xl font-serif text-navy-900 mb-6" data-id="element-131">
                  Términos y Condiciones
                </h2>
                <p data-id="element-132">
                  Al adquirir este producto digital, aceptas los siguientes
                  términos y condiciones.
                </p>
                <h3 className="font-medium text-navy-900 text-lg mt-6" data-id="element-133">
                  Producto Digital
                </h3>
                <p data-id="element-134">
                  Este es un producto digital (ebook en formato PDF). Una vez
                  completada la compra, recibirás acceso inmediato para
                  descargar el archivo. El producto es para uso personal y no
                  puede ser redistribuido, revendido ni compartido públicamente.
                </p>
                <h3 className="font-medium text-navy-900 text-lg mt-6" data-id="element-135">
                  Garantía de Devolución
                </h3>
                <p data-id="element-136">
                  Ofrecemos una garantía de devolución de 7 días. Si no estás
                  satisfecha con tu compra, puedes solicitar un reembolso
                  completo dentro de los 7 días posteriores a la compra, sin
                  preguntas.
                </p>
                <h3 className="font-medium text-navy-900 text-lg mt-6" data-id="element-137">
                  Propiedad Intelectual
                </h3>
                <p data-id="element-138">
                  Todo el contenido de este producto está protegido por derechos
                  de autor. Queda prohibida la reproducción, distribución o
                  modificación del contenido sin autorización expresa.
                </p>
                <h3 className="font-medium text-navy-900 text-lg mt-6" data-id="element-139">
                  Limitación de Responsabilidad
                </h3>
                <p data-id="element-140">
                  Este libro es una guía de bienestar emocional y no sustituye
                  el consejo profesional de un psicólogo o terapeuta. Los
                  resultados pueden variar según cada persona.
                </p>
                <h3 className="font-medium text-navy-900 text-lg mt-6" data-id="element-141">
                  Modificaciones
                </h3>
                <p data-id="element-142">
                  Nos reservamos el derecho de modificar estos términos en
                  cualquier momento. Las modificaciones entrarán en vigor desde
                  su publicación en esta página.
                </p>
              </div>}
          </div>
        </div>}
    </>;
};